import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@packages/api';

async function getInstructionSet(domainName: string, id: number, version?: string) {
  const params = version ? `?createdAt=${encodeURIComponent(version)}` : '';
  const res = await apiFetch(`/api/v17/domains/${domainName}/instructions/${id}${params}`);
  if (!res.ok) throw new Error(`Failed to fetch instruction set: ${res.status}`);
  const data = await res.json();
  return {
    ...data,
    version: version ?? res.headers.get('xm-server-time') ?? undefined,
  };
}

export function useInstructionSet(
  domainName: string | undefined,
  instructionSetId: number | undefined,
  instructionSetVersion: string | undefined,
) {
  return useQuery({
    queryKey: ['instructionSet', domainName, instructionSetId, instructionSetVersion],
    queryFn: () => getInstructionSet(domainName!, instructionSetId!, instructionSetVersion),
    enabled: !!domainName && !!instructionSetId,
  });
}
